import React from 'react';
import { useState } from 'react';
import { Modal, Loader, Table, CopyText } from '../../../../UiKit';
import { EmptyState } from '../../../commons';
import { InvalidSearchImg } from '../../../../images/images';
import { useQueryCall } from '../../../../api/react-client';

export function OrderKycStatus({ orderId, userId }) {
  const [isVisible, setIsVisible] = useState(false);

  if (!orderId && !userId) return null;

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <p className='colorGreen' onClick={() => setIsVisible(true)}>
        View Online KYC status
      </p>
      {isVisible && (
        <OrderKycStatusModal
          isVisible={isVisible}
          handleClose={() => setIsVisible(false)}
          orderId={orderId}
          userId={userId}
        />
      )}
    </>
  );
}

function OrderKycStatusModal({ orderId, userId, isVisible, handleClose }) {
  const queryKeys = [userId, orderId, 'airtel-kyc-status'];
  const getOrderIssueImgsEndPoint = `activation/get_status?order_id=${orderId}`;
  const { data, isLoading, isError } = useQueryCall(
    {},
    getOrderIssueImgsEndPoint,
    queryKeys,
  );

  const tableHeadings = [
    { name: 'Status Name', key: 1 },
    { name: 'Current Status', key: 2 },
    { name: 'Communication', key: 3 },
  ];

  const getTableRows = (data) => {
    const rowsData = [
      {
        1: { title: data?.status_name ? data?.status_name : '-' },
        2: { title: data?.status_code ? data?.status_code : '-' },
        3: {
          title: data?.status_comm ? (
            <CopyText title={data?.status_comm} />
          ) : (
            '-'
          ),
        },
      },
    ];
    return rowsData;
  };

  const getTableData = (data) => {
    const tableData = {
      headings: tableHeadings,
      rows: getTableRows(data),
    };
    return tableData;
  };

  return (
    <Modal
      isMaxContent
      isVisible={isVisible}
      type='large'
      title='Airtel SIM Activation Status'
      handleClose={handleClose}
      component={
        isLoading ? (
          <Loader />
        ) : isError ? (
          <EmptyState
            img={InvalidSearchImg}
            heading={data?.message || 'Something went wrong'}
          />
        ) : (
          <Table tableData={getTableData(data)} />
        )
      }
    />
  );
}
